import PropTypes from 'prop-types'
import React from 'react'
import UserSearchResult from './UserSearchResult'
import StyledText from '#components/a/StyledText'

function UserSearchResultError({resetSearch, errorMessage}) {
  return (
    <UserSearchResult
      modifier="error"
      resetSearch={resetSearch}
      content={<StyledText modifier="error-text" text={errorMessage} />}
    />
  )
}

UserSearchResultError.propTypes = {
  resetSearch: PropTypes.func,
  errorMessage: PropTypes.string,
}

export default UserSearchResultError
